import React from 'react';
import PropTypes from 'prop-types';
import { timezoneStringLabel } from '../../../dateUtils';

class EmployerInterviewCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
    };
  }

  handleInterviewCardClicked() {
    const { interview } = this.props;

    window.location.href = interview.interview_path;
  }

  renderInterviewTime() {
    const { interview } = this.props;

    if (interview.type === 'pending' || interview.type === 'reschedule') {
      return (
        <div className="body-text-1 medium-weight">
          {`Interview pending ${interview.type === 'pending' ? ' confirmation' : ' reschedule'}`}
        </div>
      );
    }

    const dateStr = interview.accepted_time.date;
    const startTimeStr = interview.accepted_time.start_time;
    const endTimeStr = interview.accepted_time.end_time;

    const startTimeMoment = moment(`${dateStr} ${startTimeStr}`);
    const endTimeMoment = moment(`${dateStr} ${endTimeStr}`);

    return (
      <div className="body-text-1 medium-weight">
        {startTimeMoment.format('ddd, MMM D, YYYY')}
        &nbsp;
        &middot;
        &nbsp;
        {startTimeMoment.format('h:mm a')}
        &nbsp;
        -
        &nbsp;
        {endTimeMoment.format('h:mm a')}
        <span className="ms-3 timezone muted-gray-text normal-weight">
          {timezoneStringLabel(interview.timezone)}
        </span>
      </div>
    );
  }

  render() {
    const { interview } = this.props;
    const { isHovering } = this.state;

    return (
      <div
        className="employer-interview-card width-790-centered"
        id={interview.id}
        onClick={() => this.handleInterviewCardClicked()}
        onMouseOver={() => this.setState({ isHovering: true })}
        onMouseLeave={() => this.setState({ isHovering: false })}
        role="button"
        tabIndex="0"
      >
        <div className="employer-interview-card-content">
          {this.renderInterviewTime(interview)}
        </div>
        <hr />
        <div className="employer-interview-card-content g-row--always g-row--between">
          <div className="interview-info">
            <div className="consultant-interview-info medium-weight body-text-2 mb-8">
              Interview with
              {' '}
              {interview.candidate_name}
              {' '}
              (Round
              {' '}
              {interview.round_number}
              )
            </div>
            <div className="interview-project-name normal-weight body-text-2">
              {interview.project_name}
            </div>
          </div>
          <a
            className={`${isHovering ? 'green' : 'gray'} interview-view-more-link medium-weight`}
            href={interview.interview_path}
            role="button"
            tabIndex="0"
          >
            { isHovering && <span className="body-text-2">View More</span> }
            <i className="ml-7 fas fa-angle-right arrowhead" />
          </a>
        </div>
      </div>
    );
  }
}

EmployerInterviewCard.propTypes = {
  interview: PropTypes.shape({
    project_name: PropTypes.string.isRequired,
    candidate_name: PropTypes.string.isRequired,
    round_number: PropTypes.number.isRequired,
    timezone: PropTypes.string.isRequired,
    interview_path: PropTypes.string.isRequired,
  }).isRequired,
};

export default EmployerInterviewCard;
